import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';
import FormField from '../form-field';
import money, { format } from '../../lib/money';

class PayDepositOption extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(ev) {
    if (ev.target.checked) return this.props.onDeposit();
    return this.props.onNoDeposit();
  }

  get depositAmount() { return money(this.props.depositAmount); }

  render() {
    const { merchantName } = this.props;

    if (!this.depositAmount) return null;

    return (
      <Field
        name="reserveDeposit"
        type="checkbox"
        component={FormField}
        checkbox="true"
        className="deposit-legend"
        label={
          <FormattedMessage
            id="payDepositOption.reserveDeposit.label"
            defaultMessage="Pay deposit ({amount}) yourself now to reserve inventory."
            values={{ amount: format(this.depositAmount) }}
          />
        }
        subtext={
          <FormattedMessage
            id="payDepositOption.reserveDeposit.subtext"
            defaultMessage="Will be reimbursed after everyone pays. Subject to
              {merchantName} cancellation & refund policy."
            values={{ merchantName }}
          />
        }
        onChange={this.onChange}
      />
    );
  }
}

PayDepositOption.defaultProps = {
  depositAmount: null,
  merchantName: '[Merchant Name]',
  onDeposit: () => {},
  onNoDeposit: () => {},
};

export default PayDepositOption;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/pay-deposit-option.js